const clientData = [
    { id: 1, firstName: 'Meera', lastName: 'Pal', location: 'Chandigarh'},
        // Add more client data as needed
        { id: 2, firstName: 'Mita', lastName: 'Singh', location: 'Bengaluru'},
        { id: 3, firstName: 'Mohan', lastName: 'Ras', location: 'Rajasthan'},
        { id: 4, firstName: 'Priya', lastName: 'Garg', location: 'Chattisgarh'},
        { id: 5, firstName: 'Srishti', lastName: 'Gupta', location: 'Gujarat'},
        { id: 6, firstName: 'Ram', lastName: 'Sahu', location: 'Noida'},
        { id: 7, firstName: 'Jayant', lastName: 'Sri', location: 'Mumbai'},
        { id: 8, firstName: 'Madhu', lastName: 'Kaur', location: 'Hyderabad'},
        { id: 9, firstName: 'Rishi', lastName: 'Jain', location: 'UP',},
        { id: 10, firstName: 'Sachin', lastName: 'Pal', location: 'Kolkata'},
  ];
  
  export default clientData;
  